import axios from "axios";
import cookieUtils from "../../util/cookieUtils";
import objectUtils from "../../util/objectUtils";

export default {
    state: () => ({
        token: null,
        user: null,
        selectedRoleName: null,
        panelRights : []
    }),
    mutations: {
        setUser(state, user){
            state.user = user;
        },
        setToken(state, token){
            state.token = token;
        },
        setSelectedRoleName(state, selectedRoleName){
            state.selectedRoleName = selectedRoleName;
        },
        setPanelRights(state, panelRights){
            state.panelRights = panelRights;
        }
    },
    getters: {
        getUser: state => {
            return state.user;
        },
        getToken: state => {
            return state.token;
        },
        getSelectedRoleName: state => {
            return state.selectedRoleName;
        },
        getPanelRights: state => {
            return state.panelRights;
        },
        getPanelRightsMap: state => {
            return state.panelRights.reduce(function (map,panelRight){
                map[panelRight.roleTag] = panelRight
                return map
            },{})
        }
    },
    actions: {
        login : (context, request) => {
            return axios.post(context.getters.getServiceUrl + "/auth-api/login", request,{})
                .then((response) => {
                    context.commit("setUser", response.data.user);
                    context.commit("setToken", response.data.token);

                    cookieUtils.createCookie("token", response.data.token.token)

                    context.dispatch("loadRoleRightsByGroup", {roleName:response.data.user.type})
                    return response.data;
                })
        },
        reLogin : (context, token) => {
            const headers = {
                "Authorization": "Bearer " + token
            };

            return axios.post(context.getters.getServiceUrl + "/auth-api/reLogin", {}, {headers})
                .then((response) => {
                    context.commit("setUser", response.data.user);
                    context.commit("setToken", response.data.token);

                    context.dispatch("loadRoleRightsByGroup", {roleName:response.data.user.type})

                    return response.data;
                })
        },
        logout: (context) => {
            context.commit("setUser", null)
            context.commit("setToken", null)

            cookieUtils.createCookie("token","",-1);
        },
        loadRights : (context) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/auth-right", {headers})
                .then((response) => {
                    return response.data;
                })
        },
        loadRoleRights : (context, roleName) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/auth-right/byRoleName/"+roleName, {headers})
                .then((response) => {
                    return response.data;
                })
        },
        loadRoleRightsByGroup : (context, {roleName}) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/auth-right/byRoleName/"+roleName+"/by-group/panel", {headers})
                .then((response) => {
                    context.commit("setPanelRights", response.data);
                    return response.data;
                })
                .catch(()=>{
                    context.commit("setPanelRights", []);
                })
        },
        grantRight : (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/auth-right/grant-right",request, {headers})
                .then((response) => {
                    return response.data;
                })
        },
        revokeRight : (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/auth-right/revoke-right", request, {headers})
                .then((response) => {
                    return response.data;
                })
        },
        loadAuthRoleList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/auth-role", {headers})
                .then((response) => {
                    return response.data;
                })
        },
        updateAuthRole(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.put(context.getters.getServiceUrl + "/admin-api/auth-role", request,{headers})
                .then((response) => {
                    return response.data;
                })

        },
        createAuthRole(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/auth-role", request,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        deleteAuthRole(context,request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.delete(context.getters.getServiceUrl + "/admin-api/auth-role/"+request.id,{headers})
                .then((response) => {
                    return response.data;
                })
        },
    }
}

